<form (ngSubmit)="onSubmit(form)" #form="ngForm">
	<div>
		<div class="flex justify-between mb-4">
			<span class="text-xl">Manage Accounting Codes</span>

			<img
				class="w-[120px] h-[30px]"
				src="/assets/images/integrations/soluno-logo.png "
			/>
		</div>
	</div>

	<mat-dialog-content>
		<div
			class="gap-y-4 flex gap-x-4"
			*ngIf="glAccounts.length === 0 || activityCodes.length === 0"
		>
			<div class="grid grid-cols-2 gap-4">
				<div>
					<h4>Import G/L Accounts</h4>
					<p>
						Download your G/L Account Excel file from Admin Settings > Firm >
						General Ledger Accounts in Soluno and import here.
					</p>
				</div>

				<div>
					<h4>Import Activity Codes</h4>
					<p>
						Download your Activity Code Excel file from Admin Settings >
						Rates/Codes > Activity Codes in Soluno and import here.
					</p>
				</div>

				<div class="col-start-1">
					<atomic-dropzone
						#glAccountDropzone
						[class.hidden]="glAccountFileName"
						(fileChanged)="onGLAccountFileSelected($event)"
						accept=".csv"
						label="GLAccount csv"
						[multiple]="false"
					></atomic-dropzone>

					<div
						*ngIf="glAccountFileName"
						class="bg-grey-veryLight rounded flex flex-col justify-center items-center p-9 col-start-1"
					>
						<app-icon class="text-3xl" [icon]="ICON.FILE_CHECK"></app-icon>
						<h4>Uploaded!</h4>
						<p>{{ glAccountFileName }}</p>
						<app-button
							(click)="openGLAAccountUploadMenu()"
							class="mt-2"
							size="small"
							[icon]="ICON.FILE_IMPORT"
							>Import new</app-button
						>
					</div>
				</div>

				<div class="col-start-2">
					<atomic-dropzone
						#activityCodeDropzone
						[class.hidden]="activityCodeFileName"
						(fileChanged)="onActivityCodeFileSelected($event)"
						accept=".csv"
						label="Activiy codes csv"
						[multiple]="false"
					></atomic-dropzone>

					<div
						*ngIf="activityCodeFileName"
						class="bg-grey-veryLight rounded flex flex-col justify-center items-center p-4 col-start-2"
					>
						<app-icon class="text-3xl" [icon]="ICON.FILE_CHECK"></app-icon>
						<h4>Uploaded!</h4>
						<p>{{ activityCodeFileName }}</p>
						<app-button
							(click)="openActivityCodeUploadMenu()"
							class="mt-2"
							size="small"
							[icon]="ICON.FILE_IMPORT"
							>Import new</app-button
						>
					</div>
				</div>
			</div>
		</div>

		<div *ngIf="glAccounts.length > 0 && activityCodes.length > 0" class="mt-2">
			<div class="flex gap-x-4">
				<div class="flex flex-col border rounded p-4 w-1/4">
					<div>
						<atomic-file-upload
							btnLabel="Import new"
							[fileName]="glAccountFileName"
							*ngIf="glAccounts.length > 0"
							type="stacked"
							(fileSelected)="onGLAccountFileSelected($event)"
							[fileTypeList]="['csv']"
							label="G/L Account File"
							[multiple]="false"
						></atomic-file-upload>
					</div>
					<hr class="my-4" />
					<div>
						<atomic-file-upload
							btnLabel="Import new"
							[fileName]="activityCodeFileName"
							*ngIf="activityCodes.length > 0"
							type="stacked"
							(fileSelected)="onActivityCodeFileSelected($event)"
							[fileTypeList]="['csv']"
							label="Activity Code File"
							[multiple]="false"
						></atomic-file-upload>
					</div>
					<hr class="my-4" />
					<div>
						<div class="bg-blue-lighter p-4 rounded">
							<p>
								<app-icon [icon]="ICON.LIGHT_BULB"></app-icon> To edit, add, or
								delete codes, make changes within Soluno and re-import the CSV
								files here.
							</p>
						</div>
					</div>
				</div>

				<div class="w-3/4 grid grid-cols-5 rounded border gap-2">
					<div
						class="grid grid-cols-5 bg-grey-veryLight gap-x-4 col-span-5 py-4"
					>
						<div class="col-span-1 bg-grey-veryLight rounded-l my-auto">
							<h4 class="text-base m-0 ml-2">Activity Code</h4>
						</div>
						<div class="col-span-1 bg-grey-veryLight my-auto">
							<h4 class="text-base m-0">Description</h4>
						</div>
						<div class="col-span-1 bg-grey-veryLight my-auto">
							<h4 class="text-base m-0">
								Type
								<app-icon
									class="ml-2 text-grey-light"
									matTooltip="Type specifies whether each activity code should be available for fees and/or disbursements."
									[icon]="ICON.INFO"
								></app-icon>
							</h4>
						</div>
						<div class="col-span-2 bg-grey-veryLight my-auto rounded-r">
							<h4 class="text-base m-0">
								G/L Account
								<app-icon
									class="ml-2 text-grey-light"
									matTooltip="A G/L account must be specified for each disbursement type activity code. The G/L account list is generated from the imported G/L account CSV."
									[icon]="ICON.INFO"
								></app-icon>
							</h4>
						</div>
					</div>

					<div class="col-span-5 overflow-y-auto h-[400px]">
						<div
							class="p-2 grid grid-cols-5 gap-x-4 overflow-auto min-h-0 h-[100px]"
							*ngFor="
								let activityCode of activityCodes;
								let i = index;
								trackBy: trackById
							"
						>
							<div class="col-span-1 mt-4">
								<p>{{ activityCode.id }}</p>
							</div>
							<div class="col-span-1 mt-4">
								<p>{{ activityCode.description }}</p>
							</div>
							<div class="col-span-1 mt-4 my-2">
								<app-dropdown
									[autoSelectLabel]="true"
									[submitted]="form.submitted"
									[required]="true"
									[name]="'type' + i"
									[(ngModel)]="activityCode.type"
									[itemGroups]="[{ items: activityCodeTypesDropdownOptions }]"
								></app-dropdown>
							</div>
							<div class="col-span-2 mt-4 my-2">
								<app-searchable-dropdown
									[nullable]="true"
									[backupValue]="activityCode?.GLAccount?.accountDescription"
									[name]="'glAccount' + i"
									[(ngModel)]="activityCode.GLAccount"
									[submitted]="form.submitted"
									[required]="
										activityCode.type === activityCodeTypes.DISBURSEMENT ||
										activityCode.type === activityCodeTypes.FEE_AND_DISBURSEMENT
									"
									[GLAccounts]="glAccounts"
									[items]="glAccountsDropdownOptions"
								></app-searchable-dropdown>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</mat-dialog-content>

	<mat-dialog-actions>
		<div class="w-full">
			<div
				class="flex justify-end gap-x-4 mt-4"
				*ngIf="glAccounts.length > 0 && activityCodes.length > 0"
			>
				<ui-button
					label="Cancel"
					color="gray"
					[style]="'outline'"
					mat-dialog-close
				></ui-button>
				<ui-button
					label="Save"
					type="submit"
					*ngIf="glAccounts.length > 0 && activityCodes.length > 0"
				></ui-button>
			</div>

			<div
				class="flex justify-end"
				*ngIf="glAccounts.length === 0 || activityCodes.length === 0"
			>
				<ui-button
					label="Cancel"
					color="gray"
					[style]="'outline'"
					mat-dialog-close
				></ui-button>
			</div>
		</div>
	</mat-dialog-actions>
</form>
